import FigureModel               from '@models/website/FigureModel';
import WebsiteEntertainmentModel from '@models/website/WebsiteEntertainmentModel';
import ParticipationStatusModel  from '@models/website/ParticipationStatusModel';
import doc                       from '@widesk-core/decorators/doc';
import WebsiteServiceModel       from '@/models/WebsiteServiceModel';
import Blamable                  from '@/models/traits/Blamable';
import { Addable }               from '@widesk-core/decorators/addable';
import { Editable }              from '@widesk-core/decorators/editable';
import { Deletable }             from '@widesk-core/decorators/deletable';
import { Timestampable }         from '@widesk-core/decorators/timestampable';

@doc.path('/participations/{?id}')
@doc.addable
@doc.editable
@doc.deletable
@doc.timestampable
abstract class AbstractParticipationModel extends Blamable(
	WebsiteServiceModel,
) {
	declare protected _tsFilters: {
		'partial': string;
		'availabilityIsFinal': string;
		'existsInContentToPublish': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'publishedAt[before]': id;
		'publishedAt[strictly_before]': id;
		'publishedAt[after]': id;
		'publishedAt[strictly_after]': id;
		'participationAvailabilities.date[before]': id;
		'participationAvailabilities.date[strictly_before]': id;
		'participationAvailabilities.date[after]': id;
		'participationAvailabilities.date[strictly_after]': id;
		'eventParticipations.event': id;
		'figure': id;
		'figure.figureProfessions.profession': id;
		'participationAvailabilities.date': string | Date;
		'participationPartnerships.partnership': id;
		'participationTags.tag': id;
		'participationTaxonomies.taxonomy': id;
		'participationTaxonomies.position': string;
		'participationStatus': string;
		'slug': id;
		'websiteEntertainment': id;
		'websiteEntertainment.website': id;
		'search': string;
	};

	declare private _tsSorts: {
		'daisukiCount': string;
		'id': string;
		'figure.name': string;
		'position': string;
		'createdAt': string;
		'updatedAt': string;
		'publishedAt': string;
	};

	@doc.model(FigureModel) declare figure: FigureModel;
	@doc.model(WebsiteEntertainmentModel)
	declare websiteEntertainment: WebsiteEntertainmentModel;
	@doc.string declare slug: string;
	@doc.model(ParticipationStatusModel)
	declare participationStatus: ParticipationStatusModel;
	@doc.number declare position: number;
	@doc.boolean declare availabilityIsFinal: boolean;
	@doc.date declare publishedAt: Dayjs;
	declare abstract entity: unknown;
}

interface AbstractParticipationModel
	extends Addable,
		Editable,
		Deletable,
		Timestampable {}

export default AbstractParticipationModel;
